<template>
    <div class="main-article">
        <el-row>
            <el-button @click="showArticleDialog(null)">写文章</el-button>
        </el-row>

        <el-row>
            <el-table
                :data="pageInfo.records"
                style="width: 90%">
                <el-table-column
                    width="50"
                    prop="articleId"
                    label="编号">
                </el-table-column>
                <el-table-column
                    width="150"
                    prop="title"
                    label="标题">
                </el-table-column>
                <el-table-column
                    label="摘要">
                    <el-popover 
                        slot-scope="scope"
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="scope.row.digest">
                        <span slot="reference">{{ scope.row.digest }}</span>
                    </el-popover>
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    label="更新时间"/>
                <el-table-column
                    width="250"
                    fixed="right"
                    label="操作">
                    <template slot-scope="scope">
                        <el-row :gutter="10">
                            <el-col :span="6">
                                <el-button type="primary" size="mini" @click="showArticleDialog(scope.row)">修改</el-button>
                            </el-col>
                            <el-col :span="6">
                                <el-popconfirm
                                @onConfirm="removeArticle(scope.row.articleId)"
                                title="确定删除?">
                                <el-button type="danger" size="mini" slot="reference">删除</el-button>
                                </el-popconfirm>
                            </el-col>
                        </el-row>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-dialog
            :title="article.dialogTitle"
            :visible.sync="articleDialogShow"
            :close-on-click-modal="false"
            @closed = "articleDialogClosed"
            width="50%">
            <el-row type="flex" justify="start">
                <el-col :span="21">
                    <el-input v-model="article.title" 
                    :clearable="true"
                    placeholder="标题"></el-input>
                </el-col>
            </el-row>
            <el-row type="flex" justify="start">
                <el-col :span="21">
                    <el-input v-model="article.digest" :clearable="true" type="textarea" placeholder="摘要"></el-input>
                </el-col>
            </el-row>
            <el-row type="flex" justify="start">
                <el-input placeholder="文章封面" 
                    :disabled="true"
                    v-model="article.cover" 
                    class="input-with-select">
                    <el-select v-model="article.cover" slot="prepend" placeholder="请选择">
                        <el-option
                            v-for="cover in articleImages"
                            :key="cover"
                            :label="cover"
                            :value="cover">
                            <el-popover 
                                placement="top-start"
                                trigger="hover">
                                <img :src="cover" style="width:150px;"/>
                                <span slot="reference" style="width:100%;">{{ cover }}</span>
                            </el-popover>
                        </el-option>
                    </el-select>
                </el-input>
            </el-row>
            <el-row type="flex" justify="center">
                <mavon-editor ref="md" 
                    v-model="article.markdownText" 
                    @imgAdd="fileUpload" 
                    @imgDel="removeFile"
                    @save="updateArticle"/>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import {queryArticles,updateArticle,deleteArticle} from "@/api/article.js"
import {upload,deleteFile} from "@/api/file.js"

export default {
    name: 'Phrase',
    data() {
        return {
            pageInfo: {current: 1},
            article: {markdownText: ""},
            articleDialogShow: false,
            articleImages: [],
            articleImageSet: new Set(),
        }
    },
    mounted() {
        this.findArticles()
    },
    methods: {
        findArticles(){
            queryArticles({current: this.pageInfo.current}).then(data=>{
                this.pageInfo = data.data
                if(this.pageInfo.current>this.pageInfo.pages){
                    this.pageInfo.current = this.pageInfo.pages
                    this.findArticles()
                }
            })
        },
        showArticleDialog(article){
            if(article){
                this.article=article
                this.article.dialogTitle = "修改文章"
            }else{
                this.article.dialogTitle = "写文章"
                this.article.coverList = []
            }
            this.articleDialogShow = true
        },
        articleDialogClosed(){
            this.article = this.$options.data().article
        },
        fileUpload(pos, fileObj){
            let param = new FormData();
            param.append('file', fileObj);
            upload(param).then((data)=>{
                this.$refs['md'].$img2Url(pos, "http://joburgess.cn"+data.data);
                this.articleImageSet.add("http://joburgess.cn"+data.data)
                this.articleImages = [...this.articleImageSet]
            })
        },
        removeFile(file){
            deleteFile(file[0].replace("http://joburgess.cn","")).then(()=>{})
            this.articleImageSet.delete(file[0])
            this.articleImages = [...this.articleImageSet]
            if(!this.articleImageSet.has(this.article.cover)){
                this.article.cover = ""
            }
        },
        updateArticle(content, html){
            this.article.markdownText = content
            this.article.html = html
            delete this.article.createTime
            delete this.article.updateTime
            updateArticle(this.article).then(()=>{
                this.articleDialogShow = false
                this.findArticles()
            })
        },
        removeArticle(articleId){
            deleteArticle(articleId).then(()=>{
                this.findArticles()
            })
        }
    }
}
</script>

<style lang="scss">
    .main-article {
        .el-dialog .el-row{
            margin-bottom: 15px;
        }
        .cell{
            overflow: hidden;
            white-space: nowrap;
        }
        .mavonEditor {
            width: 50%;
            height: 100%;
        }
    }
</style>